import { strMax } from '../../../utils';
export const clientSendOffValidate = {
    content: [
        strMax(2000, '面談を見送られる理由は2000文字以内で入力してください'),
    ],
};
export default clientSendOffValidate;
